import { Breadcrumb, Card, EventHandler, Label, ModalPopup, OutlineButton, PrimaryButton, ReactSelectBox, Row, SofturaTable } from "client/CommonComponents";
import Tooltip from "client/CommonComponents/Tooltip";
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup";
import { Col } from "rsuite";
import permissions, { isAuthorized } from "client/utils/Permissions";

const BranchAdminAccess = (props: any) => {
    const {
        handleClickBack,
        breadcrumlist,
        selectedUser,
        userSearchText,
        onUserChange,
        onUserInputChange,
        userSelectOnBlur,
        userOptions,
        branchAdminUserDetails,
        columns,
        fetchAction,
        serverTotal,
        pagesCount,
        tableData,
        showGrid,
        handleClickAddNew,
        hideDialog,
        showModalPopup,
        handleChangeSearchedCostCenter,
        searchCostCenter,
        costCentersBySearchList,
        selectedSearchedCostCenter,
        costCenterSearchText,
        costCenterSelectOnBlur,
        handleClickAddCostCenter,
        PopupContent,
        hidePopupDialog,
        costCenterError
    } = props
    return (
        <>
            <div className="AddUsersbycostCenter">
                <div className='CustomerMyOrder breadCrumbBlock'>
                    <div className='breadcrumb-toolbar'>
                        <EventHandler onEvent={handleClickBack} data-attribute="BranchAdminAccess_Default_EventHandler">
                            <div className='backButton mb-sm-2 mb-3'>
                                <span className="fa fa-chevron-left"></span>
                                Back
                            </div>
                        </EventHandler>                       
                        <div className='order-1'><Breadcrumb items={breadcrumlist} maxDisplayedItems='5'  data-attribute="BranchAdminAccess_Default_Breadcrumb" /></div>
                    </div>
                </div>
                <Card data-attribute="BranchAdminAccess_Default_Card">
                    <div className="admin-label blueLabel">
                        <p>Branch Admin Assignments</p>
                    </div>
                    <div>

                    </div>
                    <Row>
                        <div className="flex-adminaccesscols  ">
                            <Col xs={6} sm={6} md={6} lg={6} xl={6} className="user-label user-searchbar">
                                <label className="label"><b>User</b></label>
                                <div className="access-user">
                                    <Tooltip content={selectedUser?.label ?? ""} data-attribute="BranchAdminAccess_Default_Tooltip">
                                    <ReactSelectBox
                                        options={userOptions}
                                        onChange={(e: any, item: any) => onUserChange(e, item)}
                                        value={selectedUser || ""}
                                        name="selectedUser"
                                        isSearchable={true}
                                        inputValue={userSearchText}
                                        onInputChange={(value: any, action: any) => onUserInputChange(value, action)}
                                        className={"me-2"}
                                        onBlur={userSelectOnBlur}
                                        noOptionsMessage={() => "Not Available"}
                                     data-attribute="BranchAdminAccess_selectedUser_SearchSelectBox" />
                                    </Tooltip>
                                </div>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6} xl={6} className="branchadmindetails" >
                                <Tooltip content={branchAdminUserDetails?.fullName?.trim()?.length > 0 ? branchAdminUserDetails?.fullName : "-"} data-attribute="BranchAdminAccess_Default_Tooltip_2">
                                    <label className="label"><b>Name</b> </label>
                                    <div className="branchsubdetails dateContent">{branchAdminUserDetails?.fullName?.trim()?.length > 0 ? branchAdminUserDetails?.fullName : "-"}</div>
                                </Tooltip>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6} xl={6} className="branchadmindetails">
                                <Tooltip content={branchAdminUserDetails?.homeCostCenter?.trim()?.length > 0 ? branchAdminUserDetails?.homeCostCenter : '-'} data-attribute="BranchAdminAccess_Default_Tooltip_3">
                                    <label className="label"><b>Home Cost Center</b> </label>
                                    <div className="branchsubdetails dateContent">{branchAdminUserDetails?.homeCostCenter?.trim()?.length > 0 ? branchAdminUserDetails?.homeCostCenter : '-'}</div>
                                </Tooltip>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={6} xl={6} className="branchadmindetails">
                                <Tooltip content={branchAdminUserDetails?.status?.trim()?.length > 0 ? branchAdminUserDetails?.status : '-'} data-attribute="BranchAdminAccess_Default_Tooltip_4">
                                    <label className="label"><b>Asset Inventory Training Status</b> </label>
                                    <div className="branchsubdetails dateContent">{branchAdminUserDetails?.status?.trim()?.length > 0 ? branchAdminUserDetails?.status : '-'}</div>
                                </Tooltip>
                            </Col >
                        </div>
                    </Row>
                    {showGrid ?
                        <div>
                            <div className="table-buttons">
                                <p className="assigncostheading fs-12"><b>Assigned Cost Center</b></p>
                                {isAuthorized(permissions.Create_Branch_Admin_Assignment) &&
                                    <div>
                                        <PrimaryButton
                                            text='Add New'
                                            onClick={handleClickAddNew}
                                         data-attribute="BranchAdminAccess_Default_Button" />
                                    </div>
                                }
                            </div>
                            <div className={`pe-0 ${tableData?.length !== 0 ? "softura-table" : "softura-table paginationNav"}`}>

                                <SofturaTable
                                    data={tableData ?? []}
                                    columns={columns}
                                    sort={true}
                                    defaultPageSize={10}
                                    pageSizes={[10, 20, 50]}
                                    globalSearch={false}
                                    className={`order-listing-grid`}
                                    serverTotal={serverTotal}
                                    fetchAction={fetchAction}
                                    isServerSide={true}
                                    pagesCount={pagesCount}
                                    defaultPaginationPosition='Both'
                                    fixedHeader={true}
                                 data-attribute="BranchAdminAccess_Default_Grid" />

                            </div>
                        </div>
                        : null}
                </Card>
                {showModalPopup ?
                    <ModalPopup
                        ShowModalPopupFooter={false}
                        ModalPopupTitle="Add New Cost Center"
                        ModalPopupType="medium-large"
                        closeModalPopup={hideDialog}
                        ModalPopupName='userprofile-popup'
                     data-attribute="BranchAdminAccess_Default_ModalPopup">
                        <div className="access-user">
                            <Label required data-attribute="BranchAdminAccess_Default_Label">Cost Center</Label>
                            <Tooltip content= {selectedSearchedCostCenter?.label ?? ""} data-attribute="BranchAdminAccess_Default_Tooltip_5">
                            <ReactSelectBox
                                name='searchedCostCenter'
                                placeholder='Search Cost Center'
                                options={costCentersBySearchList}
                                onChange={(value: any) => handleChangeSearchedCostCenter(value, 'searchedCostCenter')}
                                onInputChange={searchCostCenter}
                                value={selectedSearchedCostCenter}
                                inputValue={costCenterSearchText}
                                isSearchable={true}
                                className= {costCenterError?.trim().length > 0 ? 'controlValidation' : 'mb-3 cost-centerDD'}
                                noOptionsMessage={() => "Not Available"}
                                onBlur={costCenterSelectOnBlur}
                                isClearable={true}
                             data-attribute="BranchAdminAccess_searchedCostCenter_SearchSelectBox" />
                            </Tooltip>
                            {costCenterError ? (
                                <span className="costCenter-validMessage">{costCenterError}</span>
                            ) : null}
                        </div>
                        <div className="branchattachbtn">
                            <PrimaryButton
                                text='Add'
                                onClick={handleClickAddCostCenter}
                             data-attribute="BranchAdminAccess_Default_Button_2" />
                            <OutlineButton
                                text='Cancel'
                                onClick={hideDialog}
                             data-attribute="BranchAdminAccess_Default_Button_3" />
                        </div>
                    </ModalPopup>
                    : null}
                <CompleteConfirmationPopup
                    hideDialog={hidePopupDialog}
                    onDismiss={PopupContent?.popupOutlinebtnOnclick}
                    Popupcontent={PopupContent}
                    popupOutlinebtnOnclick={PopupContent?.popupOutlinebtnOnclick}
                    popupPrimarybtnOnclick={PopupContent?.popupPrimarybtnOnclick}
                />
            </div>
        </>
    );
}
export default BranchAdminAccess;